var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 7.33333V4.66667C5.33341 3.95942 5.61437 3.28115 6.11446 2.78105C6.61456 2.28095 7.29284 2 8.00008 2C8.70733 2 9.3856 2.28095 9.8857 2.78105C10.3858 3.28115 10.6667 3.95942 10.6667 4.66667M8.00008 10V11.3333M4.00008 14H12.0001C12.3537 14 12.6928 13.8595 12.9429 13.6095C13.1929 13.3594 13.3334 13.0203 13.3334 12.6667V8.66667C13.3334 8.31304 13.1929 7.97391 12.9429 7.72386C12.6928 7.47381 12.3537 7.33333 12.0001 7.33333H4.00008C3.64646 7.33333 3.30732 7.47381 3.05727 7.72386C2.80722 7.97391 2.66675 8.31304 2.66675 8.66667V12.6667C2.66675 13.0203 2.80722 13.3594 3.05727 13.6095C3.30732 13.8595 3.64646 14 4.00008 14Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenOutline);
export default __webpack_public_path__ + "static/media/LockOpenOutline.20cb560f5a16c14c753a7a3b5f4f041e.svg";
export { ForwardRef as ReactComponent };